import { render, staticRenderFns } from "./ContactingBox.vue?vue&type=template&id=54794fcb&scoped=true&"
import script from "./ContactingBox.vue?vue&type=script&lang=js&"
export * from "./ContactingBox.vue?vue&type=script&lang=js&"
import style0 from "./ContactingBox.vue?vue&type=style&index=0&id=54794fcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54794fcb",
  null
  
)

export default component.exports